export const getQueryParam = (key: string): string | null =>
    typeof window === "undefined" ? null : new URL(window.location.href).searchParams.get(key);

